
export default {
  name: 'OtherEvents',
  props: {
    activeEvent: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      events: [],
    }
  },
  computed: {
    // берем 4 события и убираем текущее
    eventsList: function () {
      return [...this.events].filter((item) => item.slug !== this.activeEvent.slug).slice(0, 4);
    },
  },
  mounted: async function () {
    await this.getEvents();
  },
  methods: {
    getEvents: async function () {
      const response = await this.$api.agent.transport.get('/event').then((res) => {
        return res
      }).catch(() => {
        return {}
      });

      const eventsResponse = response?.data || [];

      this.events = eventsResponse;
    },
  },
};
